import { injectable } from 'inversify';

import { QuickActionCreateEvent, QuickActionLink } from '@app/gen/dashboard';

@injectable()
export class QuickActionsSettingsMapper {
  processSettingsInitialValues(links: QuickActionLink[]) {
    return {
      links: links.length
        ? links.map(({ name, url }) => ({
            name,
            url,
          }))
        : [{ name: '', url: '' }],
    };
  }

  processCompanyQuickActionsTitles(
    actions: QuickActionCreateEvent[],
  ): string[] {
    return actions.map(({ title }) => title);
  }
}
